import React, { useEffect } from "react";
import Helmet from 'react-helmet';

import "../styles/components/demo.css";

const Demo = (props) => {

  const { dark } = props;

  const initializeHubspotForm = () => {
    if ('hbspt' in window) { // Just to make sure the script is loaded (you can also do it by attaching an `onload` event to the script but I did it in this way
      window.hbspt.forms.create({
        region: "na1",
        portalId: "4759838",
        formId: "21d62bd7-e471-4496-b771-055950434956",
        target: "#book-demo-container",
      });
    } else {
      setTimeout(initializeHubspotForm, 500);
    }
  }

  useEffect(() => {
    initializeHubspotForm();
  });

  return (
    <div id="book-demo-container" className={dark ? "dark" : ""}>
      <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KTKNGPNN" title="tag-manager"
      height="0" width="0" style={{display:"none", visibility:"hidden"}}></iframe></noscript>
      <Helmet>
        <react-comment>[if lte IE 8]</react-comment>
        <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/v2-legacy.js"></script>
        <react-comment>[endif]</react-comment>
        <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/v2.js"></script>
        <script charset="utf-8" type="text/javascript" src="/gtm-demo-page.js"></script>
      </Helmet>
    </div>
  );
}

export default Demo;
